import { freddyTheme as theme } from '@coolblue-development/freddy';
const borderColor = theme.color.border;
const bgColor = theme.color.background;
const borderWidth = theme.borderWidth;
export const getCollectionDropdownContentStyles = (variant, dropdownSizeValue) => ({
    position: variant === 'default' ? 'absolute' : 'relative',
    zIndex: 6,
    width: '100%',
    boxShadow: variant === 'default' ? theme.shadow.subtle : 'initial',
    overflowY: 'auto',
    borderRadius: theme.borderRadius[100],
    maxHeight: variant === 'default' ? (dropdownSizeValue === 'extended' ? '47rem' : '40rem') : 'initial',
    'div label': {
        display: 'flex !important',
        boxShadow: 'none',
        background: bgColor.base,
        boxSizing: 'border-box',
        padding: theme.spacing[400],
        ...(variant === 'default' && {
            borderTopColor: borderColor.interactiveFocusedInner,
            borderRadius: 'initial',
        }),
    },
    'div:not(:last-child) label': {
        ...(variant === 'contentOnly' && {
            marginBottom: theme.spacing[200],
        }),
    },
    'div input:checked + label': {
        borderTop: `${borderWidth[50]} solid ${borderColor.interactiveSelected}`,
        background: bgColor.interactiveSelected,
        paddingTop: '1.5rem',
        paddingBottom: '1.5rem',
        ...(variant === 'default' && {
            margin: 'initial',
        }),
    },
    'div input:not(:checked) + label': {
        ...(variant === 'default'
            ? {
                borderLeft: `${borderWidth[50]} solid ${borderColor.interactiveFocusedInner}`,
                borderRight: `${borderWidth[50]} solid ${borderColor.interactiveFocusedInner}`,
            }
            : {
                borderLeft: `${borderWidth[25]} solid ${borderColor.base}`,
                borderRight: `${borderWidth[25]} solid ${borderColor.base}`,
            }),
        ...(variant === 'contentOnly' && {
            paddingLeft: '1.7rem !important',
            paddingRight: '1.7rem !important',
        }),
    },
    'div:first-of-type input:not(:checked) + label': {
        borderTop: variant === 'default'
            ? `${borderWidth[50]} solid ${borderColor.interactiveFocusedInner}`
            : `${borderWidth[25]} solid ${borderColor.base}`,
        ...(variant === 'default' && {
            paddingTop: '1.5rem',
        }),
        ...(variant === 'contentOnly' && {
            paddingTop: theme.spacing[400],
        }),
    },
    'div:last-of-type input:not(:checked) + label': {
        borderBottom: variant === 'default'
            ? `${borderWidth[50]} solid ${borderColor.interactiveFocusedInner}`
            : `${borderWidth[25]} solid ${borderColor.base}`,
    },
    'div input:not(:checked) + label:hover': {
        boxShadow: 'initial !important',
        background: bgColor.interactiveSelected,
        ...(variant === 'default' && {
            borderTopColor: bgColor.interactiveSelected,
            borderLeftColor: bgColor.interactiveSelected,
            borderRightColor: bgColor.interactiveSelected,
        }),
    },
    'div:last-of-type input:not(:checked) + label:hover': {
        ...(variant === 'default' && {
            borderBottomColor: bgColor.interactiveSelected,
        }),
    },
});
export const getStyledButtonStyles = (isExpanded) => ({
    border: `${borderWidth[25]} solid`,
    borderColor: isExpanded ? borderColor.interactiveHovered : borderColor.interactiveBase,
    borderRadius: theme.borderRadius[100],
    background: 'initial',
    boxShadow: 'initial',
    color: 'initial',
    fontWeight: 'initial',
    height: theme.spacing[1000],
    width: '100%',
    textAlign: 'left',
    justifyContent: 'space-between',
    alignItems: 'center',
    svg: {
        minWidth: theme.spacing[300],
    },
    '&:hover, &:active': {
        background: 'initial',
        boxShadow: 'initial',
        borderColor: borderColor.interactiveHovered,
    },
});
//# sourceMappingURL=CollectionDropdown.styled.js.map